import React from 'react';
import { Field, FieldArray, reduxForm, initialize } from 'redux-form'
import Divider from 'material-ui/Divider';
import Paper from 'material-ui/Paper';

import moment from 'moment'

import ActionDeleteIcon from 'material-ui/svg-icons/action/delete';
import DoneIcon from 'material-ui/svg-icons/action/done';
import PersonIcon from 'material-ui/svg-icons/social/person';
import ForwardIcon from 'material-ui/svg-icons/content/forward';
import ReplyIcon from 'material-ui/svg-icons/content/reply';
import MenuItem from 'material-ui/MenuItem';

import FlatButton from 'material-ui/FlatButton';
import * as colors from 'material-ui/styles/colors';

import FormSelect from '../../../components/FormSelect'
import FormLabel from '../../../components/FormLabel'
import FormAutoComplete2 from '../../../components/FormAutoComplete2'
import FormDatePicker from '../../../components/FormDatePicker'
import FormText from '../../../components/FormText'
import FormSubHolidayContents from '../../../components/FormSubHolidayContents'
import * as commons from '../../../commons';
import * as actions from '../../../actions';
import styles from '../../../styles'

import ArrowDwonloadIcon from 'material-ui/svg-icons/file/file-download';

const validateMonth = (month) => {

  if (!month || !month.length) {
    return []
  }

  let tmpList = []
  const monthErrors = []
  month.forEach((ele, index) => {
    const error = {}
    if (!ele.kind) {
      error.kind = '必須入力'
    }
    if (!ele.date) {
      error.date = '必須入力'
    } else {
      const date = moment(new Date(ele.date)).format('YYYY/MM/DD')

      if (tmpList.indexOf(date) >= 0) {
        error.date = '日付が重複しています'
      } else {
        tmpList.push(date)
      }
    }
    
    monthErrors[index] = error
  })

  return monthErrors

}

const validate = values => {
  const errors = {}

  for (let i = 0; i < 12; i++) {
    let monthErrors = validateMonth(values["month" + (i + 1)])
    if (monthErrors.length) {
      errors["month" + (i + 1)] = monthErrors
    }
  }

  return errors
}

class SystemControllAggregateForm extends React.PureComponent {
  
  constructor(props) {
    super(props)
  }

  render() {

    const { 
      initialValues,
      onSubHolidayClear,
      onDownload,
      handleSubmit,
      error,
      branchOfficeData,
      departmentData,
      selectedBranchOfficeId,
    } = this.props

    const year = initialValues.year || (new Date()).getFullYear()

    return (

      <form onSubmit={() => {}}>

        {error && <div><span style={{ color: 'rgb(244, 67, 54)' }}>{error}</span></div>}

          <div className="row">

            <div className="col-12">

              <FlatButton
                label="締め処理実行"
                labelPosition="before"
                primary={true}
                labelStyle={{ color: colors.white, lineHeight: '40px' }}
                style={{ height: '40px', width: '120px' , marginRight: '10px'}}
                backgroundColor={colors.grey600}
                hoverColor={colors.grey800}
                // icon={<ArrowDwonloadIcon color={colors.white} />}
                onClick={handleSubmit(onDownload)}
              />

            </div>

          </div>


      </form>
    );
  }
};

SystemControllAggregateForm = reduxForm({
  form: 'systemControllAggregateForm',
  enableReinitialize: true,
  validate,
  onSubmitFail: (errors, dispatch) => {
    dispatch(actions.reducerSnackBar(true, '入力内容に誤りがあります。', colors.red400))
  }
})(SystemControllAggregateForm)

export default SystemControllAggregateForm


// WEBPACK FOOTER //
// ./src/containers/master/systemControll/SystemControllAggregateForm.js